import {Flex, Text, Heading, ModalBody, GridItem} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import patternBackground from '../../../../images/Pattern_1.svg'

const Introduction = () => {
  const {t} = useTranslation('invitePayers')
  return (
    <GridItem
      alignContent="center"
      backgroundImage={patternBackground}
      backgroundColor="black"
      backgroundRepeat="repeat-x"
      backgroundSize="auto 100%"
      borderLeftRadius="lg"
      colSpan={1}
    >
      <ModalBody>
        <Flex direction="column" gap="xs">
          <Heading
            color="neutral.200"
            fontWeight="normal"
            lineHeight="90%"
            align="center"
            textTransform="uppercase"
          >
            {t('modal.steps.logoUpload.titleSection.title')}
          </Heading>
          <Text
            color="neutral.200"
            align="center"
            textTransform="uppercase"
            fontSize="sm"
          >
            {t('modal.steps.logoUpload.titleSection.subtitle')}
          </Text>
        </Flex>
      </ModalBody>
    </GridItem>
  )
}

export default Introduction
